export class Utils {
	static isObjectEmpty(obj) {
		return Object.keys(obj).length === 0;
	}

	static scrollToTop() {
		window.scrollTo(0, 0);
		return true;
	}

	static addDateLeadingZero(value) {
		return `${value}`.length === 2 ? value : `0${value}`;
	}

	static parseTime(date) {
		return `${Utils.addDateLeadingZero(date.getHours())}:${Utils.addDateLeadingZero(date.getMinutes())}:${Utils.addDateLeadingZero(date.getSeconds())}`
	}

	static parseDate(date, sign = '/') {
		return date ?
			`${date.getFullYear()}${sign}${Utils.addDateLeadingZero(date.getMonth() + 1)}${sign}${Utils.addDateLeadingZero(date.getDate())}` :
			null;
	}

	static normalizeDateForApi(date) {
		return `${this.parseDate(date, '-')} ${this.parseTime(date)}`;
	}

	static cloneObject(obj) {
		return Object.assign(Object.create( Object.getPrototypeOf(obj)), obj)
	}
}
